/* eslint-disable import/no-anonymous-default-export */
import { AxiosWrapper } from "utils/axios.helper";
import { HandleError } from "./errorHandler.service";

const GetBlacklist = (filters?: any) => {
    return AxiosWrapper({
        url: "/blacklist",
        method: "get",
        params: filters
    }).catch((error) => {
        return HandleError(error);
    });
}

export {
    GetBlacklist,
};